package com.neurobs.react.semanticui

import com.neurobs.react.ReactUtil
import slinky.core.FunctionalComponent
import slinky.core.annotations.react
import slinky.web.html._

object UiDividerFactory {

  def DividerTemplate(uiElementModifiers: UiElementModifiers) = {
    div(
      className := uiElementModifiers.formattedClassName("divider"),
      style := uiElementModifiers.createStyle
    )()
  }

  def Horizontal(implicit uiElementModifiers: UiElementModifiers) = {
    DividerTemplate(uiElementModifiers)
  }

}
